<template>
  <div>
    <v-client-table :columns="columns" :data="guiaPallets" :options="options" :theme="theme" id="dataTable">
      <template slot="actions" slot-scope="props">
        <b-col cols="12" sm="12" md="12" lg="12">
          <a href="#" @click.prevent="deletePalletGuia(props.row)" class="text-danger"
            ><i class="fa fa-close fa-lg mt-1" style="color: red"></i
          ></a>
        </b-col>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";

window.axios = require("axios");

import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import { bus } from "../../../main";

numeral.locale("es");

Vue.use(ServerTable);

export default {
  name: "AddPalletGuiaExportacion",
  components: {
    ServerTable
  },
  created() {},
  props: ["guiaPallets", "data", "deletePallet"],
  data() {
    return {
      titleModolaAddGuia: "Pallets",

      product: "",

      selected: {
        product_type: "",
        container: {
          id: ""
        }
      },
      selectOptions: {
        products: [],
        product_types: [],
        containers: []
      },
      theme: "bootstrap4",
      template: "default",
      columns: [
        "export_info.position",
        "number",
        "_origins",
        "_container",
        "_varieties",
        "_total_quantity",
        "_total_net_kilograms",
        "export_info.gross_weight",
        "export_info.position",
        "export_info.temperature",
        "export_info.temperature_recorder",
        "actions"
      ],
      options: {
        filterable: true,
        headings: {
          number: "Pallet",
          _origins: "Huertos",
          _container: "Formato",
          _varieties: "Variedades",
          _total_quantity: "Cajas",
          _total_net_kilograms: "KN",
          "export_info.gross_weight": "KB",
          "export_info.position": "Posición",
          "export_info.temperature": "Temp.",
          "export_info.temperature_recorder": "Termógrafo",
          actions: " "
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Buscar",
          filterPlaceholder: "",
          count: "",
          limit: ""
        },
        perPage: 100

        // columnsDropdown: true,
        //filterByColumn: true,
      }
    };
  },
  methods: {
    deletePalletGuia: function (row) {
      this.$emit("deletePallet", row);
    },
    loadDateTable() {
      this.$axios
        .get("/api/comex/shipment/shipping_pallets/", {
          params: {
            client: this.$store.getters.user.ID_CLIENTE,
            shipment_id: this.waybillDataExportacion.shipment.value.id
          }
        })
        .then((res) => {
          //console.log(JSON.stringify(res.data[0].packing_list)+"Aqui holagg");
          const data = res.data[0].packing_list;
          const items = [];
          for (let key in data) {
            const item = data[key];

            items.push(item);
          }
          this.data = items;
        })
        .catch((error) => console.log(errors));
    }
  },
  mounted() {
    //this.loadDateTable()
    //this.getProducts()
  },
  computed: {},
  watch: {}
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
